import { SET_CHANGE_ACCOUNT_LOADED } from "../action-types/changeAccountLoadedActionTypes";

export const setChangeAccountLoaded = (value) => {
  return {
    type: SET_CHANGE_ACCOUNT_LOADED,
    payload: value,
  };
};
